var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakeTestAccordionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FBF5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 13.75H28.525C28 12.3 26.625 11.25 25 11.25C23.375 11.25 22 12.3 21.475 13.75H16.25C14.875 13.75 13.75 14.875 13.75 16.25V33.75C13.75 35.125 14.875 36.25 16.25 36.25H33.75C35.125 36.25 36.25 35.125 36.25 33.75V16.25C36.25 14.875 35.125 13.75 33.75 13.75ZM18.75 20H21.25V25H20V21.25H18.75V20ZM22.5 31.25V32.5H18.75V31.35L21.25 28.75H18.75V27.5H21.5625C22.075 27.5 22.5 27.925 22.5 28.4375C22.5 28.6875 22.4 28.925 22.2375 29.0875L20.15 31.25H22.5ZM23.75 15C23.75 14.3125 24.3125 13.75 25 13.75C25.6875 13.75 26.25 14.3125 26.25 15C26.25 15.6875 25.6875 16.25 25 16.25C24.3125 16.25 23.75 15.6875 23.75 15ZM31.25 31.25H25V28.75H31.25V31.25ZM31.25 23.75H25V21.25H31.25V23.75Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeTestAccordionIcon);
export default __webpack_public_path__ + "static/media/take-test-accordion-icon.41d68c3794ad562f587cb2bdc8c9c50b.svg";
export { ForwardRef as ReactComponent };